const acessToken = () => {
  let inMemoryJWT = null

  const getToken = () => inMemoryJWT

  const setToken = (token) => {
    inMemoryJWT = token
    return true
  }

  const ereaseToken = () => {
    inMemoryJWT = null
    return true
  }

  return {
    ereaseToken,
    getToken,
    setToken
  }
}

export default acessToken()
